import Enhancer from '../enhancer.js';
import EnhancerApp from '../enhancer-app.js';
import MediaQueryEnhancer from './mediaquery-enhancer';

export default class HeroBadgeSpacer extends MediaQueryEnhancer {

    statusChanged(mq) {

        if (mq.matches) {
            this.setHeight();
        }
        else {
            this.resetHeight();
        }

    }

    setHeight() {
        const heroHeaderRects = this.heroHeader.getClientRects();
        const heroBadgeRects = this.heroBadge.getClientRects();

        if (heroHeaderRects.length > 0 && heroBadgeRects.length > 0) {

            const pixelsToPushDown = heroBadgeRects[0].bottom - heroHeaderRects[0].bottom;

            this.element.style.height = pixelsToPushDown + 'px';
        }
    }

    resetHeight() {
        this.element.style.height = null;
    }

    get heroHeader() {
        return document.querySelector('.hero-header');
    }

    get heroBadge() {
        return this.heroHeader.querySelector('.hero-header-badge');
    }

}

// Enhancers must be registered with a name that is used in the data-enhancer attribute
EnhancerApp.register('HeroBadgeSpacer', HeroBadgeSpacer);